import { Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { tuple_type, anonRecord_type, union_type, float64_type, array_type, class_type, option_type, bool_type, int32_type, record_type, string_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { ServiceType_$reflection, Tickets_Severity_$reflection, ServiceStatus_$reflection, Orders_OrderStatus_$reflection, Documents_DocumentSource, Documents_DocumentSource__get_Id, Environment_$reflection } from "./Shared.js";
import { now, toString } from "../fable_modules/fable-library-js.4.24.0/Date.js";

export class GenericResponse extends Record {
    constructor(Result, Message) {
        super();
        this.Result = Result;
        this.Message = Message;
    }
}

export function GenericResponse_$reflection() {
    return record_type("ApiDataTypes.GenericResponse", [], GenericResponse, () => [["Result", string_type], ["Message", string_type]]);
}

export class UserSession extends Record {
    constructor(Username, UserId, IsAdmin, IsSuperAdmin, IsPtg, TicketAccess, VersionNumber, CompanyId, Env) {
        super();
        this.Username = Username;
        this.UserId = (UserId | 0);
        this.IsAdmin = IsAdmin;
        this.IsSuperAdmin = IsSuperAdmin;
        this.IsPtg = IsPtg;
        this.TicketAccess = TicketAccess;
        this.VersionNumber = VersionNumber;
        this.CompanyId = CompanyId;
        this.Env = Env;
    }
}

export function UserSession_$reflection() {
    return record_type("ApiDataTypes.UserSession", [], UserSession, () => [["Username", string_type], ["UserId", int32_type], ["IsAdmin", bool_type], ["IsSuperAdmin", bool_type], ["IsPtg", bool_type], ["TicketAccess", bool_type], ["VersionNumber", string_type], ["CompanyId", option_type(int32_type)], ["Env", Environment_$reflection()]]);
}

export class LoginRequest extends Record {
    constructor(Email, Password) {
        super();
        this.Email = Email;
        this.Password = Password;
    }
}

export function LoginRequest_$reflection() {
    return record_type("ApiDataTypes.LoginRequest", [], LoginRequest, () => [["Email", string_type], ["Password", string_type]]);
}

export class LoginResponse extends Record {
    constructor(Result, Message, Session) {
        super();
        this.Result = Result;
        this.Message = Message;
        this.Session = Session;
    }
}

export function LoginResponse_$reflection() {
    return record_type("ApiDataTypes.LoginResponse", [], LoginResponse, () => [["Result", string_type], ["Message", string_type], ["Session", option_type(UserSession_$reflection())]]);
}

export class Account extends Record {
    constructor(AccountId, FirstName, LastName, Email, PhoneCC, Phone) {
        super();
        this.AccountId = (AccountId | 0);
        this.FirstName = FirstName;
        this.LastName = LastName;
        this.Email = Email;
        this.PhoneCC = PhoneCC;
        this.Phone = Phone;
    }
}

export function Account_$reflection() {
    return record_type("ApiDataTypes.Account", [], Account, () => [["AccountId", int32_type], ["FirstName", string_type], ["LastName", string_type], ["Email", string_type], ["PhoneCC", string_type], ["Phone", string_type]]);
}

export class AccountAssignForm extends Record {
    constructor(AccountId, TargetId) {
        super();
        this.AccountId = (AccountId | 0);
        this.TargetId = (TargetId | 0);
    }
}

export function AccountAssignForm_$reflection() {
    return record_type("ApiDataTypes.AccountAssignForm", [], AccountAssignForm, () => [["AccountId", int32_type], ["TargetId", int32_type]]);
}

export class AccountReplaceForm extends Record {
    constructor(TargetAccountId, NewAccountId, GroupId) {
        super();
        this.TargetAccountId = (TargetAccountId | 0);
        this.NewAccountId = (NewAccountId | 0);
        this.GroupId = (GroupId | 0);
    }
}

export function AccountReplaceForm_$reflection() {
    return record_type("ApiDataTypes.AccountReplaceForm", [], AccountReplaceForm, () => [["TargetAccountId", int32_type], ["NewAccountId", int32_type], ["GroupId", int32_type]]);
}

export class AuditLog extends Record {
    constructor(Id, Action, Entity, EntityId, EntityTypeId, EditDate, ColumnId, OldValue, NewValue, ChangesText, Editor) {
        super();
        this.Id = (Id | 0);
        this.Action = (Action | 0);
        this.Entity = Entity;
        this.EntityId = EntityId;
        this.EntityTypeId = (EntityTypeId | 0);
        this.EditDate = EditDate;
        this.ColumnId = ColumnId;
        this.OldValue = OldValue;
        this.NewValue = NewValue;
        this.ChangesText = ChangesText;
        this.Editor = Editor;
    }
}

export function AuditLog_$reflection() {
    return record_type("ApiDataTypes.AuditLog", [], AuditLog, () => [["Id", int32_type], ["Action", int32_type], ["Entity", string_type], ["EntityId", string_type], ["EntityTypeId", int32_type], ["EditDate", class_type("System.DateTime")], ["ColumnId", option_type(int32_type)], ["OldValue", string_type], ["NewValue", string_type], ["ChangesText", string_type], ["Editor", option_type(Account_$reflection())]]);
}

export class Department extends Record {
    constructor(Id, Enabled, Name) {
        super();
        this.Id = (Id | 0);
        this.Enabled = Enabled;
        this.Name = Name;
    }
}

export function Department_$reflection() {
    return record_type("ApiDataTypes.Department", [], Department, () => [["Id", int32_type], ["Enabled", bool_type], ["Name", string_type]]);
}

export class Company extends Record {
    constructor(Id, Name, Database, Abbr, Departments) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Database = Database;
        this.Abbr = Abbr;
        this.Departments = Departments;
    }
}

export function Company_$reflection() {
    return record_type("ApiDataTypes.Company", [], Company, () => [["Id", int32_type], ["Name", string_type], ["Database", string_type], ["Abbr", string_type], ["Departments", array_type(Department_$reflection())]]);
}

export class CompanyForm extends Record {
    constructor(Name, Database, Abbr) {
        super();
        this.Name = Name;
        this.Database = Database;
        this.Abbr = Abbr;
    }
}

export function CompanyForm_$reflection() {
    return record_type("ApiDataTypes.CompanyForm", [], CompanyForm, () => [["Name", string_type], ["Database", string_type], ["Abbr", string_type]]);
}

export class Localization extends Record {
    constructor(Language) {
        super();
        this.Language = Language;
    }
}

export function Localization_$reflection() {
    return record_type("ApiDataTypes.Localization", [], Localization, () => [["Language", string_type]]);
}

export class MachineType extends Record {
    constructor(Id, Name) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
    }
}

export function MachineType_$reflection() {
    return record_type("ApiDataTypes.MachineType", [], MachineType, () => [["Id", int32_type], ["Name", string_type]]);
}

export class Machine extends Record {
    constructor(Id, Code, Name, SerialNumber, Type, Favorite, SubGroup, WarrantyExpiry, Removed) {
        super();
        this.Id = (Id | 0);
        this.Code = Code;
        this.Name = Name;
        this.SerialNumber = SerialNumber;
        this.Type = Type;
        this.Favorite = Favorite;
        this.SubGroup = SubGroup;
        this.WarrantyExpiry = WarrantyExpiry;
        this.Removed = Removed;
    }
}

export function Machine_$reflection() {
    return record_type("ApiDataTypes.Machine", [], Machine, () => [["Id", int32_type], ["Code", string_type], ["Name", string_type], ["SerialNumber", string_type], ["Type", string_type], ["Favorite", bool_type], ["SubGroup", string_type], ["WarrantyExpiry", option_type(string_type)], ["Removed", option_type(class_type("System.DateTime"))]]);
}

export class MachineNote extends Record {
    constructor(Id, Updated, UpdatedBy, Note) {
        super();
        this.Id = (Id | 0);
        this.Updated = Updated;
        this.UpdatedBy = UpdatedBy;
        this.Note = Note;
    }
}

export function MachineNote_$reflection() {
    return record_type("ApiDataTypes.MachineNote", [], MachineNote, () => [["Id", int32_type], ["Updated", string_type], ["UpdatedBy", Account_$reflection()], ["Note", string_type]]);
}

export class MachineInfo extends Record {
    constructor(Id, Number$, Code, Name, SerialNumber, Type, Compressor, Oil, Gas, Filter, CustomerId, CustomerName, GroupId, GroupName, SubGroup, FillAmount, HandoverDate, WarrantyExpiry, LatestNote, Removed, CategoryVersion) {
        super();
        this.Id = (Id | 0);
        this.Number = Number$;
        this.Code = Code;
        this.Name = Name;
        this.SerialNumber = SerialNumber;
        this.Type = Type;
        this.Compressor = Compressor;
        this.Oil = Oil;
        this.Gas = Gas;
        this.Filter = Filter;
        this.CustomerId = (CustomerId | 0);
        this.CustomerName = CustomerName;
        this.GroupId = (GroupId | 0);
        this.GroupName = GroupName;
        this.SubGroup = SubGroup;
        this.FillAmount = FillAmount;
        this.HandoverDate = HandoverDate;
        this.WarrantyExpiry = WarrantyExpiry;
        this.LatestNote = LatestNote;
        this.Removed = Removed;
        this.CategoryVersion = CategoryVersion;
    }
}

export function MachineInfo_$reflection() {
    return record_type("ApiDataTypes.MachineInfo", [], MachineInfo, () => [["Id", int32_type], ["Number", string_type], ["Code", string_type], ["Name", string_type], ["SerialNumber", string_type], ["Type", option_type(MachineType_$reflection())], ["Compressor", string_type], ["Oil", string_type], ["Gas", string_type], ["Filter", string_type], ["CustomerId", int32_type], ["CustomerName", string_type], ["GroupId", int32_type], ["GroupName", string_type], ["SubGroup", string_type], ["FillAmount", float64_type], ["HandoverDate", option_type(string_type)], ["WarrantyExpiry", option_type(string_type)], ["LatestNote", option_type(MachineNote_$reflection())], ["Removed", option_type(class_type("System.DateTime"))], ["CategoryVersion", option_type(int32_type)]]);
}

export class DocumentVersion extends Record {
    constructor(Version, Filename, Uploader, ContentSizeBytes, Uploaded) {
        super();
        this.Version = (Version | 0);
        this.Filename = Filename;
        this.Uploader = Uploader;
        this.ContentSizeBytes = (ContentSizeBytes | 0);
        this.Uploaded = Uploaded;
    }
}

export function DocumentVersion_$reflection() {
    return record_type("ApiDataTypes.DocumentVersion", [], DocumentVersion, () => [["Version", int32_type], ["Filename", string_type], ["Uploader", option_type(Account_$reflection())], ["ContentSizeBytes", int32_type], ["Uploaded", class_type("System.DateTime")]]);
}

export class Document$ extends Record {
    constructor(Guid, Number$, CustomerId, Title, CategoryTreeId, TypeId, Machine, SourceId, Date$, Uploader, IsHidden, IsDeleted, Version, Uploaded, ManuallyMoved, ContentId, Filename, ContentSizeBytes, Versions) {
        super();
        this.Guid = Guid;
        this.Number = Number$;
        this.CustomerId = (CustomerId | 0);
        this.Title = Title;
        this.CategoryTreeId = CategoryTreeId;
        this.TypeId = TypeId;
        this.Machine = Machine;
        this.SourceId = (SourceId | 0);
        this.Date = Date$;
        this.Uploader = Uploader;
        this.IsHidden = IsHidden;
        this.IsDeleted = IsDeleted;
        this.Version = (Version | 0);
        this.Uploaded = Uploaded;
        this.ManuallyMoved = ManuallyMoved;
        this.ContentId = ContentId;
        this.Filename = Filename;
        this.ContentSizeBytes = (ContentSizeBytes | 0);
        this.Versions = Versions;
    }
}

export function Document$_$reflection() {
    return record_type("ApiDataTypes.Document", [], Document$, () => [["Guid", string_type], ["Number", option_type(int32_type)], ["CustomerId", int32_type], ["Title", string_type], ["CategoryTreeId", option_type(int32_type)], ["TypeId", option_type(int32_type)], ["Machine", option_type(Machine_$reflection())], ["SourceId", int32_type], ["Date", option_type(string_type)], ["Uploader", option_type(Account_$reflection())], ["IsHidden", bool_type], ["IsDeleted", bool_type], ["Version", int32_type], ["Uploaded", class_type("System.DateTime")], ["ManuallyMoved", bool_type], ["ContentId", option_type(int32_type)], ["Filename", string_type], ["ContentSizeBytes", int32_type], ["Versions", array_type(DocumentVersion_$reflection())]]);
}

export class DocumentTreeSyncRule extends Record {
    constructor(TargetId, TreeId, TreeName) {
        super();
        this.TargetId = (TargetId | 0);
        this.TreeId = (TreeId | 0);
        this.TreeName = TreeName;
    }
}

export function DocumentTreeSyncRule_$reflection() {
    return record_type("ApiDataTypes.DocumentTreeSyncRule", [], DocumentTreeSyncRule, () => [["TargetId", int32_type], ["TreeId", int32_type], ["TreeName", string_type]]);
}

export class DocumentCategory extends Record {
    constructor(Id, ParentId, Version, MachineId, Enabled, PtgOnly, AllowUpload, AllowMachineSubCategories, NameNO, NameEN, DescNO, DescEN, SyncRules) {
        super();
        this.Id = (Id | 0);
        this.ParentId = ParentId;
        this.Version = Version;
        this.MachineId = MachineId;
        this.Enabled = Enabled;
        this.PtgOnly = PtgOnly;
        this.AllowUpload = AllowUpload;
        this.AllowMachineSubCategories = AllowMachineSubCategories;
        this.NameNO = NameNO;
        this.NameEN = NameEN;
        this.DescNO = DescNO;
        this.DescEN = DescEN;
        this.SyncRules = SyncRules;
    }
}

export function DocumentCategory_$reflection() {
    return record_type("ApiDataTypes.DocumentCategory", [], DocumentCategory, () => [["Id", int32_type], ["ParentId", option_type(int32_type)], ["Version", option_type(int32_type)], ["MachineId", option_type(int32_type)], ["Enabled", bool_type], ["PtgOnly", bool_type], ["AllowUpload", bool_type], ["AllowMachineSubCategories", bool_type], ["NameNO", string_type], ["NameEN", string_type], ["DescNO", string_type], ["DescEN", string_type], ["SyncRules", array_type(DocumentTreeSyncRule_$reflection())]]);
}

export class DocumentTreeVersion extends Record {
    constructor(Id, Active) {
        super();
        this.Id = (Id | 0);
        this.Active = Active;
    }
}

export function DocumentTreeVersion_$reflection() {
    return record_type("ApiDataTypes.DocumentTreeVersion", [], DocumentTreeVersion, () => [["Id", int32_type], ["Active", bool_type]]);
}

export class DocumentTreeAuditLog extends Record {
    constructor(Log, TreeOpt, TreeVersionOpt) {
        super();
        this.Log = Log;
        this.TreeOpt = TreeOpt;
        this.TreeVersionOpt = TreeVersionOpt;
    }
}

export function DocumentTreeAuditLog_$reflection() {
    return record_type("ApiDataTypes.DocumentTreeAuditLog", [], DocumentTreeAuditLog, () => [["Log", AuditLog_$reflection()], ["TreeOpt", option_type(TreeInfo_$reflection())], ["TreeVersionOpt", option_type(VersionInfo_$reflection())]]);
}

export class TreeInfo extends Record {
    constructor(NameNO, NameEN) {
        super();
        this.NameNO = NameNO;
        this.NameEN = NameEN;
    }
}

export function TreeInfo_$reflection() {
    return record_type("ApiDataTypes.TreeInfo", [], TreeInfo, () => [["NameNO", string_type], ["NameEN", string_type]]);
}

export class VersionInfo extends Record {
    constructor(Active) {
        super();
        this.Active = Active;
    }
}

export function VersionInfo_$reflection() {
    return record_type("ApiDataTypes.VersionInfo", [], VersionInfo, () => [["Active", bool_type]]);
}

export class DocTreeAssign extends Record {
    constructor(MachineId, TreeId, DocId, ManuallyMoved) {
        super();
        this.MachineId = MachineId;
        this.TreeId = TreeId;
        this.DocId = DocId;
        this.ManuallyMoved = ManuallyMoved;
    }
}

export function DocTreeAssign_$reflection() {
    return record_type("ApiDataTypes.DocTreeAssign", [], DocTreeAssign, () => [["MachineId", option_type(int32_type)], ["TreeId", option_type(int32_type)], ["DocId", string_type], ["ManuallyMoved", option_type(bool_type)]]);
}

export class DocumentForm extends Record {
    constructor(Title, Filename, Content, CategoryTreeId, TypeId, Number$, Version, IsHidden, ContentSizeBytes, Date$) {
        super();
        this.Title = Title;
        this.Filename = Filename;
        this.Content = Content;
        this.CategoryTreeId = CategoryTreeId;
        this.TypeId = TypeId;
        this.Number = Number$;
        this.Version = Version;
        this.IsHidden = IsHidden;
        this.ContentSizeBytes = (ContentSizeBytes | 0);
        this.Date = Date$;
    }
}

export function DocumentForm_$reflection() {
    return record_type("ApiDataTypes.DocumentForm", [], DocumentForm, () => [["Title", string_type], ["Filename", string_type], ["Content", string_type], ["CategoryTreeId", option_type(int32_type)], ["TypeId", option_type(int32_type)], ["Number", option_type(int32_type)], ["Version", option_type(int32_type)], ["IsHidden", bool_type], ["ContentSizeBytes", int32_type], ["Date", option_type(string_type)]]);
}

export function DocumentForm_get_Empty() {
    return new DocumentForm("", "", "", undefined, undefined, undefined, undefined, false, 0, toString(now(), "yyyy-MM-dd"));
}

export class DocumentUploadForm extends Record {
    constructor(TargetId, CustomerId, MachineId, Source, Documents) {
        super();
        this.TargetId = (TargetId | 0);
        this.CustomerId = (CustomerId | 0);
        this.MachineId = MachineId;
        this.Source = (Source | 0);
        this.Documents = Documents;
    }
}

export function DocumentUploadForm_$reflection() {
    return record_type("ApiDataTypes.DocumentUploadForm", [], DocumentUploadForm, () => [["TargetId", int32_type], ["CustomerId", int32_type], ["MachineId", option_type(int32_type)], ["Source", int32_type], ["Documents", array_type(DocumentForm_$reflection())]]);
}

export function DocumentUploadForm_get_empty() {
    return new DocumentUploadForm(-1, -1, undefined, Documents_DocumentSource__get_Id(new Documents_DocumentSource(2, [])), []);
}

export class DocumentRevisionForm extends Record {
    constructor(DocumentId, DocumentNumber, Version, Title, Filename, Content, ContentSizeBytes, RevisionDate, IsHidden, CategoryTreeId, ManuallyMoved, ChangeReason) {
        super();
        this.DocumentId = DocumentId;
        this.DocumentNumber = DocumentNumber;
        this.Version = (Version | 0);
        this.Title = Title;
        this.Filename = Filename;
        this.Content = Content;
        this.ContentSizeBytes = (ContentSizeBytes | 0);
        this.RevisionDate = RevisionDate;
        this.IsHidden = IsHidden;
        this.CategoryTreeId = CategoryTreeId;
        this.ManuallyMoved = ManuallyMoved;
        this.ChangeReason = ChangeReason;
    }
}

export function DocumentRevisionForm_$reflection() {
    return record_type("ApiDataTypes.DocumentRevisionForm", [], DocumentRevisionForm, () => [["DocumentId", string_type], ["DocumentNumber", option_type(int32_type)], ["Version", int32_type], ["Title", string_type], ["Filename", string_type], ["Content", string_type], ["ContentSizeBytes", int32_type], ["RevisionDate", option_type(string_type)], ["IsHidden", bool_type], ["CategoryTreeId", option_type(int32_type)], ["ManuallyMoved", bool_type], ["ChangeReason", string_type]]);
}

export class ScanResult extends Record {
    constructor(Virus, Filename, Description) {
        super();
        this.Virus = Virus;
        this.Filename = Filename;
        this.Description = Description;
    }
}

export function ScanResult_$reflection() {
    return record_type("ApiDataTypes.ScanResult", [], ScanResult, () => [["Virus", bool_type], ["Filename", string_type], ["Description", string_type]]);
}

export class DocumentScanResult extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Virus", "NoVirus"];
    }
}

export function DocumentScanResult_$reflection() {
    return union_type("ApiDataTypes.DocumentScanResult", [], DocumentScanResult, () => [[["Item", array_type(ScanResult_$reflection())]], [["Item", array_type(Document$_$reflection())]]]);
}

export class MarketCategory extends Record {
    constructor(Id, NameNo, NameEn) {
        super();
        this.Id = (Id | 0);
        this.NameNo = NameNo;
        this.NameEn = NameEn;
    }
}

export function MarketCategory_$reflection() {
    return record_type("ApiDataTypes.MarketCategory", [], MarketCategory, () => [["Id", int32_type], ["NameNo", string_type], ["NameEn", string_type]]);
}

export class HideDocumentForm extends Record {
    constructor(DocumentId, Hidden) {
        super();
        this.DocumentId = DocumentId;
        this.Hidden = Hidden;
    }
}

export function HideDocumentForm_$reflection() {
    return record_type("ApiDataTypes.HideDocumentForm", [], HideDocumentForm, () => [["DocumentId", string_type], ["Hidden", bool_type]]);
}

export class DocumentCategoryForm extends Record {
    constructor(DocumentId, CategoryTreeId) {
        super();
        this.DocumentId = DocumentId;
        this.CategoryTreeId = CategoryTreeId;
    }
}

export function DocumentCategoryForm_$reflection() {
    return record_type("ApiDataTypes.DocumentCategoryForm", [], DocumentCategoryForm, () => [["DocumentId", string_type], ["CategoryTreeId", option_type(int32_type)]]);
}

export class OrderLine extends Record {
    constructor(Id, RowNr, Invoice, ProductNumber, TransactionDate, Description, Count, Unit, Price, Amount) {
        super();
        this.Id = (Id | 0);
        this.RowNr = (RowNr | 0);
        this.Invoice = Invoice;
        this.ProductNumber = ProductNumber;
        this.TransactionDate = TransactionDate;
        this.Description = Description;
        this.Count = Count;
        this.Unit = Unit;
        this.Price = Price;
        this.Amount = Amount;
    }
}

export function OrderLine_$reflection() {
    return record_type("ApiDataTypes.OrderLine", [], OrderLine, () => [["Id", int32_type], ["RowNr", int32_type], ["Invoice", string_type], ["ProductNumber", string_type], ["TransactionDate", string_type], ["Description", string_type], ["Count", float64_type], ["Unit", option_type(string_type)], ["Price", float64_type], ["Amount", float64_type]]);
}

export class HistoryEntry extends Record {
    constructor(InvoiceNumber, OrderNo, Date$, Technician, Details, Machine, Amount, InvoicedCustomer, InvoiceComment, Type) {
        super();
        this.InvoiceNumber = (InvoiceNumber | 0);
        this.OrderNo = (OrderNo | 0);
        this.Date = Date$;
        this.Technician = Technician;
        this.Details = Details;
        this.Machine = Machine;
        this.Amount = Amount;
        this.InvoicedCustomer = InvoicedCustomer;
        this.InvoiceComment = InvoiceComment;
        this.Type = (Type | 0);
    }
}

export function HistoryEntry_$reflection() {
    return record_type("ApiDataTypes.HistoryEntry", [], HistoryEntry, () => [["InvoiceNumber", int32_type], ["OrderNo", int32_type], ["Date", string_type], ["Technician", string_type], ["Details", string_type], ["Machine", string_type], ["Amount", float64_type], ["InvoicedCustomer", string_type], ["InvoiceComment", string_type], ["Type", int32_type]]);
}

export class GroupHistoryMachineEntry extends Record {
    constructor(MachineId, Machine, Amount) {
        super();
        this.MachineId = (MachineId | 0);
        this.Machine = Machine;
        this.Amount = Amount;
    }
}

export function GroupHistoryMachineEntry_$reflection() {
    return record_type("ApiDataTypes.GroupHistoryMachineEntry", [], GroupHistoryMachineEntry, () => [["MachineId", int32_type], ["Machine", string_type], ["Amount", float64_type]]);
}

export class GroupHistoryEntry extends Record {
    constructor(CustomerId, Customer, Amount, Machines, NonMachineAmount) {
        super();
        this.CustomerId = (CustomerId | 0);
        this.Customer = Customer;
        this.Amount = Amount;
        this.Machines = Machines;
        this.NonMachineAmount = NonMachineAmount;
    }
}

export function GroupHistoryEntry_$reflection() {
    return record_type("ApiDataTypes.GroupHistoryEntry", [], GroupHistoryEntry, () => [["CustomerId", int32_type], ["Customer", string_type], ["Amount", float64_type], ["Machines", array_type(GroupHistoryMachineEntry_$reflection())], ["NonMachineAmount", float64_type]]);
}

export class EconomyEntry extends Record {
    constructor(Year, Month, Amount) {
        super();
        this.Year = (Year | 0);
        this.Month = (Month | 0);
        this.Amount = Amount;
    }
}

export function EconomyEntry_$reflection() {
    return record_type("ApiDataTypes.EconomyEntry", [], EconomyEntry, () => [["Year", int32_type], ["Month", int32_type], ["Amount", float64_type]]);
}

export class EconomyTypedEntry extends Record {
    constructor(Year, Month, ServiceAmount, SalesAmount, ProjectAmount, OtherAmount) {
        super();
        this.Year = (Year | 0);
        this.Month = (Month | 0);
        this.ServiceAmount = ServiceAmount;
        this.SalesAmount = SalesAmount;
        this.ProjectAmount = ProjectAmount;
        this.OtherAmount = OtherAmount;
    }
}

export function EconomyTypedEntry_$reflection() {
    return record_type("ApiDataTypes.EconomyTypedEntry", [], EconomyTypedEntry, () => [["Year", int32_type], ["Month", int32_type], ["ServiceAmount", float64_type], ["SalesAmount", float64_type], ["ProjectAmount", float64_type], ["OtherAmount", float64_type]]);
}

export class EconomyTypeSpread extends Record {
    constructor(Service, Sale, Project, Other) {
        super();
        this.Service = Service;
        this.Sale = Sale;
        this.Project = Project;
        this.Other = Other;
    }
}

export function EconomyTypeSpread_$reflection() {
    return record_type("ApiDataTypes.EconomyTypeSpread", [], EconomyTypeSpread, () => [["Service", float64_type], ["Sale", float64_type], ["Project", float64_type], ["Other", float64_type]]);
}

export class CustomerGroupInfo extends Record {
    constructor(Id, Name, Company, NumCompanies, NumMachines) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Company = Company;
        this.NumCompanies = (NumCompanies | 0);
        this.NumMachines = (NumMachines | 0);
    }
}

export function CustomerGroupInfo_$reflection() {
    return record_type("ApiDataTypes.CustomerGroupInfo", [], CustomerGroupInfo, () => [["Id", int32_type], ["Name", string_type], ["Company", option_type(Company_$reflection())], ["NumCompanies", int32_type], ["NumMachines", int32_type]]);
}

export class CustomerGroup extends Record {
    constructor(Id, Name, Enabled, IsMain, IsPtg, Company) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Enabled = Enabled;
        this.IsMain = IsMain;
        this.IsPtg = IsPtg;
        this.Company = Company;
    }
}

export function CustomerGroup_$reflection() {
    return record_type("ApiDataTypes.CustomerGroup", [], CustomerGroup, () => [["Id", int32_type], ["Name", string_type], ["Enabled", bool_type], ["IsMain", bool_type], ["IsPtg", bool_type], ["Company", option_type(Company_$reflection())]]);
}

export class Customer extends Record {
    constructor(Id, Name, Groups) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Groups = Groups;
    }
}

export function Customer_$reflection() {
    return record_type("ApiDataTypes.Customer", [], Customer, () => [["Id", int32_type], ["Name", string_type], ["Groups", array_type(CustomerGroup_$reflection())]]);
}

export class CustomerServiceAgreement extends Record {
    constructor(Id, CustomerId, AgreementName, CompanyName, EndDate) {
        super();
        this.Id = (Id | 0);
        this.CustomerId = (CustomerId | 0);
        this.AgreementName = AgreementName;
        this.CompanyName = CompanyName;
        this.EndDate = EndDate;
    }
}

export function CustomerServiceAgreement_$reflection() {
    return record_type("ApiDataTypes.CustomerServiceAgreement", [], CustomerServiceAgreement, () => [["Id", int32_type], ["CustomerId", int32_type], ["AgreementName", string_type], ["CompanyName", string_type], ["EndDate", option_type(string_type)]]);
}

export class CustomerInfo extends Record {
    constructor(Id, Number$, Name, Enabled, EnableServices, EnableExtra, HasAgreement, Favorite, Memo, Responsible, ServiceLead, Machines, MarketCategories, Groups) {
        super();
        this.Id = (Id | 0);
        this.Number = (Number$ | 0);
        this.Name = Name;
        this.Enabled = Enabled;
        this.EnableServices = EnableServices;
        this.EnableExtra = EnableExtra;
        this.HasAgreement = HasAgreement;
        this.Favorite = Favorite;
        this.Memo = Memo;
        this.Responsible = Responsible;
        this.ServiceLead = ServiceLead;
        this.Machines = Machines;
        this.MarketCategories = MarketCategories;
        this.Groups = Groups;
    }
}

export function CustomerInfo_$reflection() {
    return record_type("ApiDataTypes.CustomerInfo", [], CustomerInfo, () => [["Id", int32_type], ["Number", int32_type], ["Name", string_type], ["Enabled", bool_type], ["EnableServices", bool_type], ["EnableExtra", bool_type], ["HasAgreement", bool_type], ["Favorite", bool_type], ["Memo", option_type(string_type)], ["Responsible", option_type(Account_$reflection())], ["ServiceLead", option_type(Account_$reflection())], ["Machines", array_type(Machine_$reflection())], ["MarketCategories", array_type(MarketCategory_$reflection())], ["Groups", array_type(CustomerGroup_$reflection())]]);
}

export class CustomerGroupWithMembers extends Record {
    constructor(Id, Name, Enabled, IsMain, IsPtg, Favorite, Company, Customers) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Enabled = Enabled;
        this.IsMain = IsMain;
        this.IsPtg = IsPtg;
        this.Favorite = Favorite;
        this.Company = Company;
        this.Customers = Customers;
    }
}

export function CustomerGroupWithMembers_$reflection() {
    return record_type("ApiDataTypes.CustomerGroupWithMembers", [], CustomerGroupWithMembers, () => [["Id", int32_type], ["Name", string_type], ["Enabled", bool_type], ["IsMain", bool_type], ["IsPtg", bool_type], ["Favorite", bool_type], ["Company", option_type(Company_$reflection())], ["Customers", array_type(CustomerInfo_$reflection())]]);
}

export class CustomerContact extends Record {
    constructor(CustomerId, Customer, Filename, FileExt) {
        super();
        this.CustomerId = (CustomerId | 0);
        this.Customer = Customer;
        this.Filename = Filename;
        this.FileExt = FileExt;
    }
}

export function CustomerContact_$reflection() {
    return record_type("ApiDataTypes.CustomerContact", [], CustomerContact, () => [["CustomerId", int32_type], ["Customer", string_type], ["Filename", string_type], ["FileExt", string_type]]);
}

export class CustomerContactForm extends Record {
    constructor(CustomerId, Filename, Content) {
        super();
        this.CustomerId = (CustomerId | 0);
        this.Filename = Filename;
        this.Content = Content;
    }
}

export function CustomerContactForm_$reflection() {
    return record_type("ApiDataTypes.CustomerContactForm", [], CustomerContactForm, () => [["CustomerId", int32_type], ["Filename", string_type], ["Content", string_type]]);
}

export class SearchInput extends Record {
    constructor(Term) {
        super();
        this.Term = Term;
    }
}

export function SearchInput_$reflection() {
    return record_type("ApiDataTypes.SearchInput", [], SearchInput, () => [["Term", string_type]]);
}

export class AccessRequest extends Record {
    constructor(AccountId, CustomerId) {
        super();
        this.AccountId = (AccountId | 0);
        this.CustomerId = (CustomerId | 0);
    }
}

export function AccessRequest_$reflection() {
    return record_type("ApiDataTypes.AccessRequest", [], AccessRequest, () => [["AccountId", int32_type], ["CustomerId", int32_type]]);
}

export class AccountAccess extends Record {
    constructor(AccountId, CustomerId, Customer, GroupId, Group) {
        super();
        this.AccountId = (AccountId | 0);
        this.CustomerId = (CustomerId | 0);
        this.Customer = Customer;
        this.GroupId = (GroupId | 0);
        this.Group = Group;
    }
}

export function AccountAccess_$reflection() {
    return record_type("ApiDataTypes.AccountAccess", [], AccountAccess, () => [["AccountId", int32_type], ["CustomerId", int32_type], ["Customer", string_type], ["GroupId", int32_type], ["Group", string_type]]);
}

export class AccountInfo extends Record {
    constructor(Id, Email, FirstName, LastName, PhoneCC, Phone, IsAdmin, IsSuperAdmin, IsPtg, TwoFactor, ForcedTfa, TicketSystem, Enabled, Company, Groups) {
        super();
        this.Id = (Id | 0);
        this.Email = Email;
        this.FirstName = FirstName;
        this.LastName = LastName;
        this.PhoneCC = PhoneCC;
        this.Phone = Phone;
        this.IsAdmin = IsAdmin;
        this.IsSuperAdmin = IsSuperAdmin;
        this.IsPtg = IsPtg;
        this.TwoFactor = TwoFactor;
        this.ForcedTfa = ForcedTfa;
        this.TicketSystem = TicketSystem;
        this.Enabled = Enabled;
        this.Company = Company;
        this.Groups = Groups;
    }
}

export function AccountInfo_$reflection() {
    return record_type("ApiDataTypes.AccountInfo", [], AccountInfo, () => [["Id", int32_type], ["Email", string_type], ["FirstName", string_type], ["LastName", string_type], ["PhoneCC", string_type], ["Phone", string_type], ["IsAdmin", bool_type], ["IsSuperAdmin", bool_type], ["IsPtg", bool_type], ["TwoFactor", bool_type], ["ForcedTfa", bool_type], ["TicketSystem", bool_type], ["Enabled", bool_type], ["Company", option_type(Company_$reflection())], ["Groups", array_type(CustomerGroup_$reflection())]]);
}

export class PaginatedAccountResponse extends Record {
    constructor(Page, Entries) {
        super();
        this.Page = (Page | 0);
        this.Entries = Entries;
    }
}

export function PaginatedAccountResponse_$reflection() {
    return record_type("ApiDataTypes.PaginatedAccountResponse", [], PaginatedAccountResponse, () => [["Page", int32_type], ["Entries", array_type(AccountInfo_$reflection())]]);
}

export class LogEntry extends Record {
    constructor(ChangedItem, OldValue, NewValue, ChangeDate, UserInfo) {
        super();
        this.ChangedItem = ChangedItem;
        this.OldValue = OldValue;
        this.NewValue = NewValue;
        this.ChangeDate = ChangeDate;
        this.UserInfo = UserInfo;
    }
}

export function LogEntry_$reflection() {
    return record_type("ApiDataTypes.LogEntry", [], LogEntry, () => [["ChangedItem", string_type], ["OldValue", string_type], ["NewValue", string_type], ["ChangeDate", string_type], ["UserInfo", anonRecord_type(["Email", string_type], ["UserId", int32_type])]]);
}

export class GasType extends Record {
    constructor(Id, Name) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
    }
}

export function GasType_$reflection() {
    return record_type("ApiDataTypes.GasType", [], GasType, () => [["Id", int32_type], ["Name", string_type]]);
}

export class GasReportEntry extends Record {
    constructor(MachineId, MachineCode, MachineName, Action, Amount, Date$, OrderNr, SourceId, GasType, GasText, Result, ProductNr) {
        super();
        this.MachineId = (MachineId | 0);
        this.MachineCode = MachineCode;
        this.MachineName = MachineName;
        this.Action = (Action | 0);
        this.Amount = Amount;
        this.Date = Date$;
        this.OrderNr = (OrderNr | 0);
        this.SourceId = (SourceId | 0);
        this.GasType = GasType;
        this.GasText = GasText;
        this.Result = Result;
        this.ProductNr = ProductNr;
    }
}

export function GasReportEntry_$reflection() {
    return record_type("ApiDataTypes.GasReportEntry", [], GasReportEntry, () => [["MachineId", int32_type], ["MachineCode", string_type], ["MachineName", string_type], ["Action", int32_type], ["Amount", option_type(float64_type)], ["Date", option_type(string_type)], ["OrderNr", int32_type], ["SourceId", int32_type], ["GasType", option_type(GasType_$reflection())], ["GasText", string_type], ["Result", option_type(string_type)], ["ProductNr", string_type]]);
}

export class CustomerPending extends Record {
    constructor(Id, Name, CustomerNumber, InvoiceCustomer, Synced) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.CustomerNumber = (CustomerNumber | 0);
        this.InvoiceCustomer = InvoiceCustomer;
        this.Synced = Synced;
    }
}

export function CustomerPending_$reflection() {
    return record_type("ApiDataTypes.CustomerPending", [], CustomerPending, () => [["Id", int32_type], ["Name", string_type], ["CustomerNumber", int32_type], ["InvoiceCustomer", option_type(anonRecord_type(["CustomerNumber", int32_type], ["Name", option_type(string_type)]))], ["Synced", class_type("System.DateTime")]]);
}

export class Order extends Record {
    constructor(Id, Number$, TicketId, Status, Date$, Desc, Company, Department, Customer) {
        super();
        this.Id = (Id | 0);
        this.Number = (Number$ | 0);
        this.TicketId = TicketId;
        this.Status = Status;
        this.Date = Date$;
        this.Desc = Desc;
        this.Company = Company;
        this.Department = Department;
        this.Customer = Customer;
    }
}

export function Order_$reflection() {
    return record_type("ApiDataTypes.Order", [], Order, () => [["Id", int32_type], ["Number", int32_type], ["TicketId", option_type(int32_type)], ["Status", Orders_OrderStatus_$reflection()], ["Date", string_type], ["Desc", string_type], ["Company", Company_$reflection()], ["Department", option_type(Department_$reflection())], ["Customer", Customer_$reflection()]]);
}

export class Service extends Record {
    constructor(Id, CreatedById, CreatedBy, Status, ClosingComment, Severity, Type, Description, VismaOrder, CustomerId, Customer, MachineId, MachineName, MachineCode, TicketIdOpt, NotifyInternally, InternalRecipients, NotifyCustomers, CustomerRecipients, PlannedDate, NotifyDate, CompletedDate) {
        super();
        this.Id = (Id | 0);
        this.CreatedById = (CreatedById | 0);
        this.CreatedBy = CreatedBy;
        this.Status = Status;
        this.ClosingComment = ClosingComment;
        this.Severity = Severity;
        this.Type = Type;
        this.Description = Description;
        this.VismaOrder = VismaOrder;
        this.CustomerId = (CustomerId | 0);
        this.Customer = Customer;
        this.MachineId = (MachineId | 0);
        this.MachineName = MachineName;
        this.MachineCode = MachineCode;
        this.TicketIdOpt = TicketIdOpt;
        this.NotifyInternally = NotifyInternally;
        this.InternalRecipients = InternalRecipients;
        this.NotifyCustomers = NotifyCustomers;
        this.CustomerRecipients = CustomerRecipients;
        this.PlannedDate = PlannedDate;
        this.NotifyDate = NotifyDate;
        this.CompletedDate = CompletedDate;
    }
}

export function Service_$reflection() {
    return record_type("ApiDataTypes.Service", [], Service, () => [["Id", int32_type], ["CreatedById", int32_type], ["CreatedBy", tuple_type(string_type, string_type)], ["Status", ServiceStatus_$reflection()], ["ClosingComment", string_type], ["Severity", Tickets_Severity_$reflection()], ["Type", option_type(ServiceType_$reflection())], ["Description", string_type], ["VismaOrder", string_type], ["CustomerId", int32_type], ["Customer", string_type], ["MachineId", int32_type], ["MachineName", string_type], ["MachineCode", string_type], ["TicketIdOpt", option_type(int32_type)], ["NotifyInternally", bool_type], ["InternalRecipients", array_type(string_type)], ["NotifyCustomers", bool_type], ["CustomerRecipients", array_type(string_type)], ["PlannedDate", string_type], ["NotifyDate", option_type(string_type)], ["CompletedDate", option_type(class_type("System.DateTime"))]]);
}

export class Tickets_TicketMachine extends Record {
    constructor(Code, Name) {
        super();
        this.Code = Code;
        this.Name = Name;
    }
}

export function Tickets_TicketMachine_$reflection() {
    return record_type("ApiDataTypes.Tickets.TicketMachine", [], Tickets_TicketMachine, () => [["Code", string_type], ["Name", string_type]]);
}

export class Tickets_TicketContact extends Record {
    constructor(Name, Email, PhoneCC, Phone) {
        super();
        this.Name = Name;
        this.Email = Email;
        this.PhoneCC = PhoneCC;
        this.Phone = Phone;
    }
}

export function Tickets_TicketContact_$reflection() {
    return record_type("ApiDataTypes.Tickets.TicketContact", [], Tickets_TicketContact, () => [["Name", string_type], ["Email", string_type], ["PhoneCC", string_type], ["Phone", string_type]]);
}

export class Tickets_TicketMeta extends Record {
    constructor(Id, DepartmentId, Date$, Type, Segment, Status, Severity, CriticalOperationalHalt, ShortDesc, Customer, Contact, Creator, Responsible, Machines, IsHidden, VismaOrderNo, Order) {
        super();
        this.Id = (Id | 0);
        this.DepartmentId = DepartmentId;
        this.Date = Date$;
        this.Type = (Type | 0);
        this.Segment = (Segment | 0);
        this.Status = (Status | 0);
        this.Severity = (Severity | 0);
        this.CriticalOperationalHalt = CriticalOperationalHalt;
        this.ShortDesc = ShortDesc;
        this.Customer = Customer;
        this.Contact = Contact;
        this.Creator = Creator;
        this.Responsible = Responsible;
        this.Machines = Machines;
        this.IsHidden = IsHidden;
        this.VismaOrderNo = VismaOrderNo;
        this.Order = Order;
    }
}

export function Tickets_TicketMeta_$reflection() {
    return record_type("ApiDataTypes.Tickets.TicketMeta", [], Tickets_TicketMeta, () => [["Id", int32_type], ["DepartmentId", option_type(int32_type)], ["Date", string_type], ["Type", int32_type], ["Segment", int32_type], ["Status", int32_type], ["Severity", int32_type], ["CriticalOperationalHalt", bool_type], ["ShortDesc", string_type], ["Customer", Customer_$reflection()], ["Contact", Tickets_TicketContact_$reflection()], ["Creator", Account_$reflection()], ["Responsible", option_type(Account_$reflection())], ["Machines", array_type(Tickets_TicketMachine_$reflection())], ["IsHidden", bool_type], ["VismaOrderNo", string_type], ["Order", option_type(Order_$reflection())]]);
}

export class Tickets_WarrantyPart extends Record {
    constructor(Id, PartNo, Num, Desc) {
        super();
        this.Id = (Id | 0);
        this.PartNo = PartNo;
        this.Num = (Num | 0);
        this.Desc = Desc;
    }
}

export function Tickets_WarrantyPart_$reflection() {
    return record_type("ApiDataTypes.Tickets.WarrantyPart", [], Tickets_WarrantyPart, () => [["Id", int32_type], ["PartNo", string_type], ["Num", int32_type], ["Desc", string_type]]);
}

export class Tickets_Ticket extends Record {
    constructor(Id, Company, DepartmentId, Customer, Date$, Type, Status, Severity, CriticalOperationalHalt, Segment, Category, UtilityClass, Machines, ShortDesc, Desc, Desc2, Resolution, CreatedBy, Contact, Responsible, SendUpdateEmail, VismaOrderNo, VismaOrder, WarrantyType, WarrantyTypeText, WarrantyReservation, WarrantyReservationDesc, WarrantyParts, Activities, TotalTime, Billable, IsHidden) {
        super();
        this.Id = (Id | 0);
        this.Company = Company;
        this.DepartmentId = DepartmentId;
        this.Customer = Customer;
        this.Date = Date$;
        this.Type = (Type | 0);
        this.Status = (Status | 0);
        this.Severity = (Severity | 0);
        this.CriticalOperationalHalt = CriticalOperationalHalt;
        this.Segment = (Segment | 0);
        this.Category = (Category | 0);
        this.UtilityClass = (UtilityClass | 0);
        this.Machines = Machines;
        this.ShortDesc = ShortDesc;
        this.Desc = Desc;
        this.Desc2 = Desc2;
        this.Resolution = Resolution;
        this.CreatedBy = CreatedBy;
        this.Contact = Contact;
        this.Responsible = Responsible;
        this.SendUpdateEmail = SendUpdateEmail;
        this.VismaOrderNo = VismaOrderNo;
        this.VismaOrder = VismaOrder;
        this.WarrantyType = WarrantyType;
        this.WarrantyTypeText = WarrantyTypeText;
        this.WarrantyReservation = WarrantyReservation;
        this.WarrantyReservationDesc = WarrantyReservationDesc;
        this.WarrantyParts = WarrantyParts;
        this.Activities = Activities;
        this.TotalTime = (TotalTime | 0);
        this.Billable = (Billable | 0);
        this.IsHidden = IsHidden;
    }
}

export function Tickets_Ticket_$reflection() {
    return record_type("ApiDataTypes.Tickets.Ticket", [], Tickets_Ticket, () => [["Id", int32_type], ["Company", option_type(Company_$reflection())], ["DepartmentId", option_type(int32_type)], ["Customer", CustomerInfo_$reflection()], ["Date", string_type], ["Type", int32_type], ["Status", int32_type], ["Severity", int32_type], ["CriticalOperationalHalt", bool_type], ["Segment", int32_type], ["Category", int32_type], ["UtilityClass", int32_type], ["Machines", array_type(Machine_$reflection())], ["ShortDesc", string_type], ["Desc", string_type], ["Desc2", string_type], ["Resolution", string_type], ["CreatedBy", Account_$reflection()], ["Contact", Tickets_TicketContact_$reflection()], ["Responsible", option_type(Account_$reflection())], ["SendUpdateEmail", bool_type], ["VismaOrderNo", string_type], ["VismaOrder", option_type(Order_$reflection())], ["WarrantyType", option_type(int32_type)], ["WarrantyTypeText", string_type], ["WarrantyReservation", option_type(bool_type)], ["WarrantyReservationDesc", string_type], ["WarrantyParts", array_type(Tickets_WarrantyPart_$reflection())], ["Activities", array_type(Service_$reflection())], ["TotalTime", int32_type], ["Billable", int32_type], ["IsHidden", bool_type]]);
}

export class Tickets_TicketForm extends Record {
    constructor(DepartmentId, CustomerId, CustomerOrder, Contact, Responsible, ShortDesc, Desc, Desc2, CriticalOperationalHalt, TicketType, Segment, Category, Severity, UtilityClass, Machines, WarrantyType, WarrantyTypeText, WarrantyReservation, WarrantyReservationDesc, WarrantyParts, Activities, IsHidden) {
        super();
        this.DepartmentId = (DepartmentId | 0);
        this.CustomerId = (CustomerId | 0);
        this.CustomerOrder = CustomerOrder;
        this.Contact = Contact;
        this.Responsible = Responsible;
        this.ShortDesc = ShortDesc;
        this.Desc = Desc;
        this.Desc2 = Desc2;
        this.CriticalOperationalHalt = CriticalOperationalHalt;
        this.TicketType = (TicketType | 0);
        this.Segment = (Segment | 0);
        this.Category = (Category | 0);
        this.Severity = (Severity | 0);
        this.UtilityClass = (UtilityClass | 0);
        this.Machines = Machines;
        this.WarrantyType = WarrantyType;
        this.WarrantyTypeText = WarrantyTypeText;
        this.WarrantyReservation = WarrantyReservation;
        this.WarrantyReservationDesc = WarrantyReservationDesc;
        this.WarrantyParts = WarrantyParts;
        this.Activities = Activities;
        this.IsHidden = IsHidden;
    }
}

export function Tickets_TicketForm_$reflection() {
    return record_type("ApiDataTypes.Tickets.TicketForm", [], Tickets_TicketForm, () => [["DepartmentId", int32_type], ["CustomerId", int32_type], ["CustomerOrder", option_type(Order_$reflection())], ["Contact", Tickets_TicketContact_$reflection()], ["Responsible", option_type(Account_$reflection())], ["ShortDesc", string_type], ["Desc", string_type], ["Desc2", string_type], ["CriticalOperationalHalt", bool_type], ["TicketType", int32_type], ["Segment", int32_type], ["Category", int32_type], ["Severity", int32_type], ["UtilityClass", int32_type], ["Machines", array_type(int32_type)], ["WarrantyType", option_type(int32_type)], ["WarrantyTypeText", string_type], ["WarrantyReservation", option_type(bool_type)], ["WarrantyReservationDesc", string_type], ["WarrantyParts", array_type(Tickets_WarrantyPart_$reflection())], ["Activities", array_type(Service_$reflection())], ["IsHidden", bool_type]]);
}

export class Tickets_AttachmentMeta extends Record {
    constructor(Id, Hidden, Filename, Desc, Uploaded, UploadedBy) {
        super();
        this.Id = (Id | 0);
        this.Hidden = Hidden;
        this.Filename = Filename;
        this.Desc = Desc;
        this.Uploaded = Uploaded;
        this.UploadedBy = UploadedBy;
    }
}

export function Tickets_AttachmentMeta_$reflection() {
    return record_type("ApiDataTypes.Tickets.AttachmentMeta", [], Tickets_AttachmentMeta, () => [["Id", int32_type], ["Hidden", bool_type], ["Filename", string_type], ["Desc", string_type], ["Uploaded", class_type("System.DateTime")], ["UploadedBy", Account_$reflection()]]);
}

export class Tickets_AttachmentForm extends Record {
    constructor(TicketId, Desc, Filename, Content, IsHidden) {
        super();
        this.TicketId = (TicketId | 0);
        this.Desc = Desc;
        this.Filename = Filename;
        this.Content = Content;
        this.IsHidden = IsHidden;
    }
}

export function Tickets_AttachmentForm_$reflection() {
    return record_type("ApiDataTypes.Tickets.AttachmentForm", [], Tickets_AttachmentForm, () => [["TicketId", int32_type], ["Desc", string_type], ["Filename", string_type], ["Content", string_type], ["IsHidden", bool_type]]);
}

export class Tickets_HideAttachmentForm extends Record {
    constructor(AttachmentId, IsHidden) {
        super();
        this.AttachmentId = (AttachmentId | 0);
        this.IsHidden = IsHidden;
    }
}

export function Tickets_HideAttachmentForm_$reflection() {
    return record_type("ApiDataTypes.Tickets.HideAttachmentForm", [], Tickets_HideAttachmentForm, () => [["AttachmentId", int32_type], ["IsHidden", bool_type]]);
}

export class Tickets_TicketStatusForm extends Record {
    constructor(TicketId, Status) {
        super();
        this.TicketId = (TicketId | 0);
        this.Status = (Status | 0);
    }
}

export function Tickets_TicketStatusForm_$reflection() {
    return record_type("ApiDataTypes.Tickets.TicketStatusForm", [], Tickets_TicketStatusForm, () => [["TicketId", int32_type], ["Status", int32_type]]);
}

export class Tickets_TimeEntry extends Record {
    constructor(Id, Registered, StartTime, Minutes, Billable, Desc, Account) {
        super();
        this.Id = (Id | 0);
        this.Registered = Registered;
        this.StartTime = StartTime;
        this.Minutes = (Minutes | 0);
        this.Billable = Billable;
        this.Desc = Desc;
        this.Account = Account;
    }
}

export function Tickets_TimeEntry_$reflection() {
    return record_type("ApiDataTypes.Tickets.TimeEntry", [], Tickets_TimeEntry, () => [["Id", int32_type], ["Registered", string_type], ["StartTime", string_type], ["Minutes", int32_type], ["Billable", bool_type], ["Desc", string_type], ["Account", Account_$reflection()]]);
}

export class Tickets_TimeForm extends Record {
    constructor(TicketId, StartTime, Minutes, Billable, Desc) {
        super();
        this.TicketId = (TicketId | 0);
        this.StartTime = StartTime;
        this.Minutes = (Minutes | 0);
        this.Billable = Billable;
        this.Desc = Desc;
    }
}

export function Tickets_TimeForm_$reflection() {
    return record_type("ApiDataTypes.Tickets.TimeForm", [], Tickets_TimeForm, () => [["TicketId", int32_type], ["StartTime", class_type("System.DateTime")], ["Minutes", int32_type], ["Billable", bool_type], ["Desc", string_type]]);
}

export class Dashboard_CohSummary extends Record {
    constructor(PeriodTotal, Open, Closed) {
        super();
        this.PeriodTotal = (PeriodTotal | 0);
        this.Open = (Open | 0);
        this.Closed = (Closed | 0);
    }
}

export function Dashboard_CohSummary_$reflection() {
    return record_type("ApiDataTypes.Dashboard.CohSummary", [], Dashboard_CohSummary, () => [["PeriodTotal", int32_type], ["Open", int32_type], ["Closed", int32_type]]);
}

export class Dashboard_CohCompanyEntry extends Record {
    constructor(CompanyId, Company, Num) {
        super();
        this.CompanyId = (CompanyId | 0);
        this.Company = Company;
        this.Num = (Num | 0);
    }
}

export function Dashboard_CohCompanyEntry_$reflection() {
    return record_type("ApiDataTypes.Dashboard.CohCompanyEntry", [], Dashboard_CohCompanyEntry, () => [["CompanyId", int32_type], ["Company", string_type], ["Num", int32_type]]);
}

export class Dashboard_CohStatusSummary extends Record {
    constructor(NumCritical, NumOpen, NumReopened, NumInProgress, NumHold, NumClosed) {
        super();
        this.NumCritical = (NumCritical | 0);
        this.NumOpen = (NumOpen | 0);
        this.NumReopened = (NumReopened | 0);
        this.NumInProgress = (NumInProgress | 0);
        this.NumHold = (NumHold | 0);
        this.NumClosed = (NumClosed | 0);
    }
}

export function Dashboard_CohStatusSummary_$reflection() {
    return record_type("ApiDataTypes.Dashboard.CohStatusSummary", [], Dashboard_CohStatusSummary, () => [["NumCritical", int32_type], ["NumOpen", int32_type], ["NumReopened", int32_type], ["NumInProgress", int32_type], ["NumHold", int32_type], ["NumClosed", int32_type]]);
}

export class Dashboard_CohSeverityEntry extends Record {
    constructor(SeverityId, Num) {
        super();
        this.SeverityId = (SeverityId | 0);
        this.Num = (Num | 0);
    }
}

export function Dashboard_CohSeverityEntry_$reflection() {
    return record_type("ApiDataTypes.Dashboard.CohSeverityEntry", [], Dashboard_CohSeverityEntry, () => [["SeverityId", int32_type], ["Num", int32_type]]);
}

export class Dashboard_TypeSummaryEntry extends Record {
    constructor(TypeId, Num) {
        super();
        this.TypeId = (TypeId | 0);
        this.Num = (Num | 0);
    }
}

export function Dashboard_TypeSummaryEntry_$reflection() {
    return record_type("ApiDataTypes.Dashboard.TypeSummaryEntry", [], Dashboard_TypeSummaryEntry, () => [["TypeId", int32_type], ["Num", int32_type]]);
}

export class Dashboard_UsageEntry extends Record {
    constructor(Date$, Num) {
        super();
        this.Date = Date$;
        this.Num = (Num | 0);
    }
}

export function Dashboard_UsageEntry_$reflection() {
    return record_type("ApiDataTypes.Dashboard.UsageEntry", [], Dashboard_UsageEntry, () => [["Date", class_type("System.DateTime")], ["Num", int32_type]]);
}

export class Dashboard_UsageSummary extends Record {
    constructor(Today, LastSeven, ThisWeek, PreviousWeek) {
        super();
        this.Today = (Today | 0);
        this.LastSeven = (LastSeven | 0);
        this.ThisWeek = (ThisWeek | 0);
        this.PreviousWeek = (PreviousWeek | 0);
    }
}

export function Dashboard_UsageSummary_$reflection() {
    return record_type("ApiDataTypes.Dashboard.UsageSummary", [], Dashboard_UsageSummary, () => [["Today", int32_type], ["LastSeven", int32_type], ["ThisWeek", int32_type], ["PreviousWeek", int32_type]]);
}

export class Dashboard_CustomerUsageSummary extends Record {
    constructor(LastWeek, LastMonth, LastYear) {
        super();
        this.LastWeek = (LastWeek | 0);
        this.LastMonth = (LastMonth | 0);
        this.LastYear = (LastYear | 0);
    }
}

export function Dashboard_CustomerUsageSummary_$reflection() {
    return record_type("ApiDataTypes.Dashboard.CustomerUsageSummary", [], Dashboard_CustomerUsageSummary, () => [["LastWeek", int32_type], ["LastMonth", int32_type], ["LastYear", int32_type]]);
}

export class Dashboard_ActivitiesSummary extends Record {
    constructor(Today, Tomorrow, ThisWeek, Month, LastSeven) {
        super();
        this.Today = (Today | 0);
        this.Tomorrow = (Tomorrow | 0);
        this.ThisWeek = (ThisWeek | 0);
        this.Month = (Month | 0);
        this.LastSeven = (LastSeven | 0);
    }
}

export function Dashboard_ActivitiesSummary_$reflection() {
    return record_type("ApiDataTypes.Dashboard.ActivitiesSummary", [], Dashboard_ActivitiesSummary, () => [["Today", int32_type], ["Tomorrow", int32_type], ["ThisWeek", int32_type], ["Month", int32_type], ["LastSeven", int32_type]]);
}

export class Dashboard_ActivityCompanyEntry extends Record {
    constructor(CompanyId, Company, Num) {
        super();
        this.CompanyId = (CompanyId | 0);
        this.Company = Company;
        this.Num = (Num | 0);
    }
}

export function Dashboard_ActivityCompanyEntry_$reflection() {
    return record_type("ApiDataTypes.Dashboard.ActivityCompanyEntry", [], Dashboard_ActivityCompanyEntry, () => [["CompanyId", int32_type], ["Company", string_type], ["Num", int32_type]]);
}

export class Dashboard_CompanyTicketEntry extends Record {
    constructor(CompanyId, Company, NumOpen, NumCritical, NumClosed, NumDurationWeek, NumDurationMonth, NumDurationYear) {
        super();
        this.CompanyId = (CompanyId | 0);
        this.Company = Company;
        this.NumOpen = (NumOpen | 0);
        this.NumCritical = (NumCritical | 0);
        this.NumClosed = (NumClosed | 0);
        this.NumDurationWeek = (NumDurationWeek | 0);
        this.NumDurationMonth = (NumDurationMonth | 0);
        this.NumDurationYear = (NumDurationYear | 0);
    }
}

export function Dashboard_CompanyTicketEntry_$reflection() {
    return record_type("ApiDataTypes.Dashboard.CompanyTicketEntry", [], Dashboard_CompanyTicketEntry, () => [["CompanyId", int32_type], ["Company", string_type], ["NumOpen", int32_type], ["NumCritical", int32_type], ["NumClosed", int32_type], ["NumDurationWeek", int32_type], ["NumDurationMonth", int32_type], ["NumDurationYear", int32_type]]);
}

export class Dashboard_CustomerTicketEntry extends Record {
    constructor(CustomerId, Customer, NumOpen, NumClosed, NumCritical) {
        super();
        this.CustomerId = (CustomerId | 0);
        this.Customer = Customer;
        this.NumOpen = (NumOpen | 0);
        this.NumClosed = (NumClosed | 0);
        this.NumCritical = (NumCritical | 0);
    }
}

export function Dashboard_CustomerTicketEntry_$reflection() {
    return record_type("ApiDataTypes.Dashboard.CustomerTicketEntry", [], Dashboard_CustomerTicketEntry, () => [["CustomerId", int32_type], ["Customer", string_type], ["NumOpen", int32_type], ["NumClosed", int32_type], ["NumCritical", int32_type]]);
}

export class Dashboard_AccountTicketEntry extends Record {
    constructor(Firstname, Lastname, Email, NumOpen, NumClosed, NumCritical, NumMonthOld, NumYearOld) {
        super();
        this.Firstname = Firstname;
        this.Lastname = Lastname;
        this.Email = Email;
        this.NumOpen = (NumOpen | 0);
        this.NumClosed = (NumClosed | 0);
        this.NumCritical = (NumCritical | 0);
        this.NumMonthOld = (NumMonthOld | 0);
        this.NumYearOld = (NumYearOld | 0);
    }
}

export function Dashboard_AccountTicketEntry_$reflection() {
    return record_type("ApiDataTypes.Dashboard.AccountTicketEntry", [], Dashboard_AccountTicketEntry, () => [["Firstname", string_type], ["Lastname", string_type], ["Email", string_type], ["NumOpen", int32_type], ["NumClosed", int32_type], ["NumCritical", int32_type], ["NumMonthOld", int32_type], ["NumYearOld", int32_type]]);
}

export class DocumentSync_Document extends Record {
    constructor(Guid, Title, Filename, Created, Modified, SizeKb, Type, Content, CustomerNo, SourceSystem, Deleted, CompanyId, DocumentId, Version) {
        super();
        this.Guid = Guid;
        this.Title = Title;
        this.Filename = Filename;
        this.Created = Created;
        this.Modified = Modified;
        this.SizeKb = SizeKb;
        this.Type = Type;
        this.Content = Content;
        this.CustomerNo = CustomerNo;
        this.SourceSystem = SourceSystem;
        this.Deleted = Deleted;
        this.CompanyId = CompanyId;
        this.DocumentId = (DocumentId | 0);
        this.Version = Version;
    }
}

export function DocumentSync_Document_$reflection() {
    return record_type("ApiDataTypes.DocumentSync.Document", [], DocumentSync_Document, () => [["Guid", option_type(string_type)], ["Title", string_type], ["Filename", option_type(string_type)], ["Created", option_type(class_type("System.DateTime"))], ["Modified", option_type(class_type("System.DateTime"))], ["SizeKb", option_type(int32_type)], ["Type", option_type(string_type)], ["Content", string_type], ["CustomerNo", string_type], ["SourceSystem", string_type], ["Deleted", option_type(bool_type)], ["CompanyId", option_type(int32_type)], ["DocumentId", int32_type], ["Version", option_type(int32_type)]]);
}

export class CustomerService extends Record {
    constructor(Customer, Services) {
        super();
        this.Customer = Customer;
        this.Services = Services;
    }
}

export function CustomerService_$reflection() {
    return record_type("ApiDataTypes.CustomerService", [], CustomerService, () => [["Customer", Customer_$reflection()], ["Services", array_type(Service_$reflection())]]);
}

export class ServiceTicket extends Record {
    constructor(TicketOpt, Services) {
        super();
        this.TicketOpt = TicketOpt;
        this.Services = Services;
    }
}

export function ServiceTicket_$reflection() {
    return record_type("ApiDataTypes.ServiceTicket", [], ServiceTicket, () => [["TicketOpt", option_type(Tickets_TicketForm_$reflection())], ["Services", array_type(Service_$reflection())]]);
}

export class SparePart extends Record {
    constructor(Id, Code, ProductDescription, ItemCount) {
        super();
        this.Id = (Id | 0);
        this.Code = Code;
        this.ProductDescription = ProductDescription;
        this.ItemCount = ItemCount;
    }
}

export function SparePart_$reflection() {
    return record_type("ApiDataTypes.SparePart", [], SparePart, () => [["Id", int32_type], ["Code", string_type], ["ProductDescription", string_type], ["ItemCount", float64_type]]);
}

export class SparePartOrder extends Record {
    constructor(Id, IncludeAssembly, RequestOffer, Comment$, Complete, Cancelled, CancellationReason, Address1, Address2, PostalCode, PostArea, Country, Ordered, Account, OrderedSpareParts) {
        super();
        this.Id = (Id | 0);
        this.IncludeAssembly = IncludeAssembly;
        this.RequestOffer = RequestOffer;
        this.Comment = Comment$;
        this.Complete = Complete;
        this.Cancelled = Cancelled;
        this.CancellationReason = CancellationReason;
        this.Address1 = Address1;
        this.Address2 = Address2;
        this.PostalCode = (PostalCode | 0);
        this.PostArea = PostArea;
        this.Country = Country;
        this.Ordered = Ordered;
        this.Account = Account;
        this.OrderedSpareParts = OrderedSpareParts;
    }
}

export function SparePartOrder_$reflection() {
    return record_type("ApiDataTypes.SparePartOrder", [], SparePartOrder, () => [["Id", int32_type], ["IncludeAssembly", bool_type], ["RequestOffer", bool_type], ["Comment", string_type], ["Complete", bool_type], ["Cancelled", bool_type], ["CancellationReason", string_type], ["Address1", string_type], ["Address2", string_type], ["PostalCode", int32_type], ["PostArea", string_type], ["Country", string_type], ["Ordered", class_type("System.DateTime")], ["Account", AccountInfo_$reflection()], ["OrderedSpareParts", array_type(OrderedSparePart_$reflection())]]);
}

export class OrderedSparePart extends Record {
    constructor(Amount, SparePart) {
        super();
        this.Amount = Amount;
        this.SparePart = SparePart;
    }
}

export function OrderedSparePart_$reflection() {
    return record_type("ApiDataTypes.OrderedSparePart", [], OrderedSparePart, () => [["Amount", float64_type], ["SparePart", SparePart_$reflection()]]);
}

